@if(featureDynamicService.donationTeaser) {
<app-donation></app-donation>
}
<app-sommerfest-teaser></app-sommerfest-teaser>
@if(((newsResource.value()?.newsArticles) ?? []).length > 0
&&!currentRouteService.currentRoute().startsWith('/aktuell')) {
<!-- @defer { -->
<app-news-next></app-news-next>
<!-- } @placeholder (minimum 250ms) {
<div></div>
} -->
}
@if(eventService.nextEvents().length > 0
&& !currentRouteService.currentRoute().startsWith('/aktuell')
&& !currentRouteService.currentRoute().startsWith('/termine')){
<!-- @defer { -->
<app-events-next></app-events-next>
<!-- } @placeholder (minimum 250ms) {
<div></div>
} -->
}
@if((weatherService.observation$ | async)
&& !currentRouteService.currentRoute().startsWith('/wetter')
&& !currentRouteService.currentRoute().startsWith('/aktuell')
&& !currentRouteService.currentRoute().startsWith('/termine')) {
<!-- @defer { -->
<app-weather></app-weather>
<!-- } @placeholder (minimum 250ms) {
<div></div>
} -->
}
@defer (on viewport; prefetch on idle) {
<app-sponsors appearance="SIDEBAR" />
} @placeholder {
<div></div>
}

<!-- Instagram link -->
<div class="fbLink">
    <a mat-button href="https://www.instagram.com/yachtclubsteinhudermeer/" target="_blank">
        <img src="assets/img/instagram-logo.png" width="100" height="100" alt="Instagram" class="fbImg">YSTM bei
        Instagram</a>
</div>
<!-- Facebook link -->
<div class="fbLink">
    <a mat-button href="https://www.facebook.com/ystm.eu/" target="_blank">
        <img src="assets/img/Facebook_Logo_Primary-sm.png" width="100" height="100" alt="Facebook" class="fbImg">YSTM
        bei
        Facebook</a>
</div>